import React, { Fragment, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HomeContext } from "./index";
import { getAllCategory } from "../../admin/categories/FetchApi";
import { getAllProduct, productByPrice } from "../../admin/products/FetchApi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";

const CategoryList = () => {
  const history = useHistory();
  const { data } = useContext(HomeContext);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseData = await getAllCategory();
        if (responseData?.Categories) {
          setCategories(responseData.Categories);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchData();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 200,
    slidesToShow: 4,
    centerMode: true,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2, centerMode: true } },
    ],
  };

  return (
    <div className={`${data.categoryListDropdown ? "" : "hidden"} my-6`}>
      {categories.length > 0 ? (
        <Slider {...settings}>
          {categories.map((item, index) => (
            <div
              key={index}
              onClick={() => history.push(`/products/category/${item._id}`)}
              className="mx-4 min-w-[140px] px-4 py-3 rounded-md bg-white transition-all duration-300 cursor-pointer flex items-center justify-center"
            >
              <div className="text-sm font-medium text-gray-900 text-center leading-tight tracking-wide whitespace-nowrap overflow-hidden text-ellipsis w-full">
                {item.cName}
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <div className="text-xl text-center my-4 text-gray-500">Nenhuma Categoria</div>
      )}
    </div>
  );
};

const FilterList = () => {
  const { data, dispatch } = useContext(HomeContext);
  const [range, setRange] = useState(0);

  const rangeHandle = (e) => {
    setRange(e.target.value);
    fetchData(e.target.value);
  };

  const fetchData = async (price) => {
    if (price === "all") {
      try {
        let responseData = await getAllProduct();
        if (responseData?.Products) {
          dispatch({ type: "setProducts", payload: responseData.Products });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      dispatch({ type: "loading", payload: true });
      try {
        setTimeout(async () => {
          let responseData = await productByPrice(price);
          if (responseData?.Products) {
            dispatch({ type: "setProducts", payload: responseData.Products });
            dispatch({ type: "loading", payload: false });
          }
        }, 700);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const closeFilterBar = () => {
    fetchData("all");
    dispatch({ type: "filterListDropdown", payload: !data.filterListDropdown });
    setRange(0);
  };

  return (
    <div className={`${data.filterListDropdown ? "" : "hidden"} my-4`}>
      <div className="w-full max-w-3xl mx-auto bg-white rounded-xl shadow-md p-5 border border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Filtrar por Preço</h2>
          <button onClick={closeFilterBar} aria-label="Fechar filtros">
            <svg
              className="w-7 h-7 text-gray-600 hover:text-red-500 transition"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <label htmlFor="price-range" className="block text-sm text-gray-600 mb-2">
          Escolha um valor entre <strong>R$0</strong> e <strong>R$1000</strong>
        </label>

        <div className="flex items-center space-x-4">
          <input
            id="price-range"
            type="range"
            min="0"
            max="1000"
            step="10"
            value={range}
            onChange={rangeHandle}
            className="w-full accent-green-800"
          />
          <span className="text-green-800 font-semibold text-md">R${range}</span>
        </div>
      </div>
    </div>
  );
};

const Search = () => {
  const { data, dispatch } = useContext(HomeContext);
  const [search, setSearch] = useState("");
  const [productArray, setProductArray] = useState(null);

  const searchHandle = (e) => {
    setSearch(e.target.value);
    fetchData();
    dispatch({
      type: "searchHandleInReducer",
      payload: e.target.value,
      productArray: productArray,
    });
  };

  const fetchData = async () => {
    dispatch({ type: "loading", payload: true });
    try {
      setTimeout(async () => {
        let responseData = await getAllProduct();
        if (responseData?.Products) {
          setProductArray(responseData.Products);
          dispatch({ type: "loading", payload: false });
        }
      }, 700);
    } catch (error) {
      console.log(error);
    }
  };

  const closeSearchBar = () => {
    dispatch({ type: "searchDropdown", payload: !data.searchDropdown });
    fetchData();
    dispatch({ type: "setProducts", payload: productArray });
    setSearch("");
  };

  return (
    <div
      className={`${
        data.searchDropdown ? "" : "hidden"
      } my-4 flex items-center justify-between w-full max-w-md mx-auto px-4`}
    >
      <div className="relative w-full">
        <input
          value={search}
          onChange={(e) => searchHandle(e)}
          className="px-4 py-2 text-xl focus:outline-none w-full border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-green-500"
          type="text"
          placeholder="Pesquise por produtos..."
        />
        <div className="absolute top-0 right-0 flex items-center h-full pr-3">
          <svg
            className="w-6 h-6 text-gray-500 cursor-pointer hover:text-gray-700"
            onClick={() => closeSearchBar()}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

const ProductCategoryDropdown = () => {
  return (
    <Fragment>
      <CategoryList />
      <FilterList />
      <Search />
    </Fragment>
  );
};

export default ProductCategoryDropdown;